import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    { path: '/', name: 'home', redirect: '/auth' },
    { path: '/test', name: 'test', component: () => import('@/views/testView') },
    { path: '/auth', name: 'auth', children: [
        { path: '', name: 'auth-home', meta: { auth: false }, component: () => import('@/views/LoginView.vue') },
        { path: 'verify', name: 'auth-verify', meta: { auth: false }, component: () => import('@/views/verifyView.vue') }
    ]},
    { path: '/user', name: 'user', meta: { auth: true }, children: [
        { path: '', name: 'user-dashboard', component: () => import('@/views/DashboardView.vue') },
        { path: 'jobs', name: 'user-jobs', component: () => import('@/views/DashboardView.vue') },
    ]},
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('@/views/404View.vue') }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach(async (to, from, next) => {
    try {
        const middlewares = await import('./middlewares/laod');
        await middlewares.loadmiddlewares(to, from, next);
    } catch (error) {
        next({ name: 'errorPage' });
    }
});

export default router
